export default __webpack_public_path__ + "static/media/1844.65ab3277.png";